import { useEffect, useState } from 'react'

/**
 * モバイルデバイスの横向き検出
 * デスクトップ（タッチ非対応）では常にfalseを返す
 */
export const useOrientation = () => {
  const [isLandscape, setIsLandscape] = useState(false)

  useEffect(() => {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0

    const handleOrientationChange = () => {
      if (!isTouchDevice) {
        setIsLandscape(false)
        return
      }
      setIsLandscape(window.matchMedia('(orientation: landscape)').matches)
    }

    handleOrientationChange()

    window.addEventListener('resize', handleOrientationChange)

    return () => {
      window.removeEventListener('resize', handleOrientationChange)
    }
  }, [])

  return isLandscape
}
